$shm_tests_release $mol_book2_catalog
	menu_title \Проекты и релизы
	param \release_project
	menu_filter_enabled true
	Project* $mol_book2
		pages <= project_pages* /$mol_view
	Overview* $mol_page
		title <= project_title* \
		body /
			<= Project_info* $mol_text
				text <= project_info* \
			<= Channels* $mol_view
				sub /
					<= Prerelease* $mol_text
						text <= prerelease_title* \
					<= Stable* $mol_text
						text <= stable_title* \
	History* $mol_page
		title \История изменений
		body <= release_rows* /$mol_view
	Release* $mol_view
		sub /
			<= Release_title* $mol_view
				sub / <= release_title* \
			<= Release_meta* $mol_text
				text <= release_meta* \
			<= Release_notes* $mol_text
				text <= release_notes* \
	Empty $mol_paragraph
		title \Для проекта пока нет пререлизов и релизов.
